import LoaderSpinner from "@components/atoms/LoaderSpinner/LoaderSpinner";
import { cn } from "@utils/utils";
import React from "react";
import styles from "./SpecificationSection.module.scss";

interface LoadingProps {
  className?: string;
}

export const Loading: React.FC<LoadingProps> = ({ className }) => {
  return (
    <div className={cn(styles.specs, className)}>
      <h2 className={styles.specs__title}>All specifications</h2>

      {/* Variant selector skeleton */}
      <div className={styles.specs__variant}>
        <div className={styles.specs__variantButton}>
          <span>Loading variants...</span>
          <LoaderSpinner />
        </div>
      </div>

      <div className={styles.specs__content}>
        {/* Tabs skeleton */}
        <div className={styles.specs__tabs}>
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className={styles.specs__tab}>
              <LoaderSpinner />
            </div>
          ))}
        </div>

        {/* Tab content skeleton */}
        <div className={styles.specs__tabContent}>
          <div className={styles.specs__features}>
            <div className={styles.specs__featureColumn}>
              <h3 className={styles.specs__featureTitle}>
                Loading features...
              </h3>
              <div className={styles.specs__featureList}>
                <LoaderSpinner />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
